import { useLang } from '../../providers/i18n/tazmeni18n';

const useIsRtl = () => {
  const lang = useLang();
  return lang !== 'en';
};

export default useIsRtl;
